import type { ReactNode } from 'react';
import Breadcrumb, { type Crumb } from '@/components/base/Breadcrumb';

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs: Crumb[];
  meta?: ReactNode;
  children?: ReactNode;
};

export default function PageHeader({ eyebrow, title, description, crumbs, meta, children }: PageHeaderProps) {
  return (
    <section className="relative overflow-hidden border-b border-background-800/80 bg-gradient-to-b from-primary-950/50 via-background-950 to-background-950">
      <div className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full bg-primary-600/20 blur-3xl" />
      <div className="relative mx-auto max-w-content px-4 pb-8 pt-6 md:px-6 md:pb-12 md:pt-8">
        <Breadcrumb items={crumbs} />
        {eyebrow && (
          <p className="mt-6 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.28em] text-accent-500">
            <span className="inline-block h-px w-6 bg-accent-500/70" />
            {eyebrow}
          </p>
        )}
        <h1 className="mt-2.5 text-3xl font-black tracking-tight text-foreground-50 md:text-4xl lg:text-5xl">{title}</h1>
        {description && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-[15px]">{description}</p>}
        {meta && <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">{meta}</div>}
        {children}
      </div>
    </section>
  );
}